import { Button, Dialog, DialogContent, DialogFooter, DialogTrigger, Text } from '@chatsdet/ui';

interface TestRunConfirmationDialogsProps {
  cancelTargetId: string | null;
  deleteTargetId: string | null;
  isCancelPending: boolean;
  isDeletePending: boolean;
  onCancelTargetChange: (executionId: string | null) => void;
  onDeleteTargetChange: (executionId: string | null) => void;
  onConfirmCancel: () => Promise<void> | void;
  onConfirmDelete: () => Promise<void> | void;
}

export function TestRunConfirmationDialogs({
  cancelTargetId,
  deleteTargetId,
  isCancelPending,
  isDeletePending,
  onCancelTargetChange,
  onDeleteTargetChange,
  onConfirmCancel,
  onConfirmDelete,
}: TestRunConfirmationDialogsProps) {
  return (
    <>
      <DialogTrigger
        isOpen={!!cancelTargetId}
        onOpenChange={(open) => !open && onCancelTargetChange(null)}
        size="sm"
      >
        <span />
        <Dialog
          title="Cancel test run"
          description="Are you sure you want to cancel this test run?"
        >
          <DialogContent>
            <Text>
              This will cancel the execution and stop all queued and running workflow tests.
            </Text>
          </DialogContent>
          <DialogFooter>
            <Button
              variant="outline"
              onPress={() => onCancelTargetChange(null)}
              isDisabled={isCancelPending}
            >
              Keep Running
            </Button>
            <Button
              variant="destructive"
              onPress={onConfirmCancel}
              isDisabled={isCancelPending}
            >
              {isCancelPending ? 'Canceling...' : 'Cancel Run'}
            </Button>
          </DialogFooter>
        </Dialog>
      </DialogTrigger>

      <DialogTrigger
        isOpen={!!deleteTargetId}
        onOpenChange={(open) => !open && onDeleteTargetChange(null)}
        size="sm"
      >
        <span />
        <Dialog
          title="Delete test run"
          description="Are you sure you want to delete this test run?"
        >
          <DialogContent>
            <Text>
              This will permanently delete the execution and all its test results. This action
              cannot be undone.
            </Text>
          </DialogContent>
          <DialogFooter>
            <Button
              variant="outline"
              onPress={() => onDeleteTargetChange(null)}
              isDisabled={isDeletePending}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onPress={onConfirmDelete}
              isDisabled={isDeletePending}
            >
              {isDeletePending ? 'Deleting...' : 'Delete Run'}
            </Button>
          </DialogFooter>
        </Dialog>
      </DialogTrigger>
    </>
  );
}
